import logo from './logo.svg';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './components/dashboard.jsx'
import Sidebar from './components/sidebar.jsx';
import Login from './components/login.jsx';


function App() {
  return (
<div>
      <Routes>
      <Route path="/" element={<><Sidebar/><Dashboard/> </>} />
      <Route path="/login" element={<Login/>} />
      </Routes>
</div>
  );
}

export default App;
